import { lazy } from 'react';

const Form = lazy(() => import('./Form'));

export { Form };
